import { render, staticRenderFns } from "./AddFaceInfor.vue?vue&type=template&id=76272264&scoped=true&"
import script from "./AddFaceInfor.vue?vue&type=script&lang=js&"
export * from "./AddFaceInfor.vue?vue&type=script&lang=js&"
import style0 from "./AddFaceInfor.vue?vue&type=style&index=0&id=76272264&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76272264",
  null
  
)

export default component.exports